// @flow
import { error } from './common';
import * as types from '../types/monitors';
import type { ROUTE_TYPE } from '../types/routes';
import type {
  MONITOR_FETCH_STARTED_TYPE,
  MONITOR_FETCH_SUCCEED_TYPE,
  MONITOR_ROUTES_FETCH_STARTED_TYPE,
  ADD_MONITOR_ROUTE_STARTED_TYPE,
  ADD_MONITOR_ROUTE_SUCCESS_TYPE,
  MONITOR_ROUTES_FETCH_SUCCEED_TYPE,
  ADD_MONITOR_ROUTES_TYPE,
  ADD_MONITOR_DAY_ROUTES_TYPE,
  MONITOR_TYPE,
  MONITORS_REGISTERED_TYPE,
  UPDATE_MONITOR_SUCCEED_TYPE,
  UPDATE_MONITOR_STARTED_TYPE,
} from '../types/monitors';


export const startFetchingMonitor = (id: number): MONITOR_FETCH_STARTED_TYPE => ({
  type: types.MONITOR_FETCH_STARTED,
  payload: id,
});

export const fetchMonitorSucceed = (
  id: number,
  first_name: string,
  last_name: string,
  phone: string,
  profile_picture: string,
): MONITOR_FETCH_SUCCEED_TYPE => ({
  type: types.MONITOR_FETCH_SUCCEED,
  payload: {
    id,
    first_name,
    last_name,
    phone,
    profile_picture,
  },
});

export const fetchMonitorFailed = error(types.MONITOR_FETCH_FAILED);

export const startFetchingMonitorRoutes = (id: number): MONITOR_ROUTES_FETCH_STARTED_TYPE => ({
  type: types.MONITOR_ROUTES_FETCH_STARTED,
  payload: id,
});

export const fetchMonitorRoutesSucceed = (
  entities: {[number]: ROUTE_TYPE},
  order: Array<number>,
): MONITOR_ROUTES_FETCH_SUCCEED_TYPE => ({
  type: types.MONITOR_ROUTES_FETCH_SUCCEED,
  payload: { entities, order },
});

export const addMonitorRoutes = (
  id: number,
  routes: Array<number>,
): ADD_MONITOR_ROUTES_TYPE => ({
  type: types.ADD_MONITOR_ROUTES,
  payload: { id, routes },
});

export const addMonitorDayRoutes = (
  id: number,
  routes: Array<number>,
): ADD_MONITOR_DAY_ROUTES_TYPE => ({
  type: types.ADD_MONITOR_DAY_ROUTES,
  payload: { id, routes },
});

export const fetchMonitorRoutesFailed = error(types.MONITOR_ROUTES_FETCH_FAILED);

export const registerMonitors = (
  entities: {[number]: MONITOR_TYPE},
): MONITORS_REGISTERED_TYPE => ({
  type: types.MONITORS_REGISTERED,
  payload: {
    entities,
  },
});

export const addMonitorRouteStarted = (
  id: number,
  idRoute: number,
): ADD_MONITOR_ROUTE_STARTED_TYPE => ({
  type: types.ADD_MONITOR_ROUTE_STARTED,
  payload: { id, idRoute },
});

export const addMonitorRouteSuccess = (id: number, routes: Array<number>): ADD_MONITOR_ROUTE_SUCCESS_TYPE => ({
  type: types.ADD_MONITOR_ROUTE_SUCCESS,
  payload: {
    id,
    routes,
  },
});

export const addMonitorRouteFailed = error(types.ADD_MONITOR_ROUTE_FAILED);

export const updateMonitorStart = (changed_monitor: Object): UPDATE_MONITOR_STARTED_TYPE => ({
  type: types.UPDATE_MONITOR_STARTED,
  payload: changed_monitor,
});

export const updateMonitorSuccess = (monitor: MONITOR_TYPE): UPDATE_MONITOR_SUCCEED_TYPE => ({
  type: types.UPDATE_MONITOR_SUCCEED,
  payload: monitor,
});

export const updateMonitorFailed = error(types.UPDATE_MONITOR_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/monitors.js